const ZendeskBeacon = {
  init: function () {
    const contactButtons = document.querySelectorAll('.js-beacon')

    // Show beacon on contact buttons
    contactButtons.forEach(function (el) {
      el.addEventListener('click', ZendeskBeacon.contactButtonHandler)
    })
  },

  contactButtonHandler: function (evt) {
    evt.preventDefault()
    try {
      if (window.Forethought && typeof window.Forethought === 'function') {
        window.Forethought('widget', 'open')
      }
    } catch (err) {
      console.error('Error opening support widget:', err)
    }
  },
}

window.addEventListener('DOMContentLoaded', ZendeskBeacon.init)
